// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/public/images/hero-image.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  background: linear-gradient(rgba(0, 0, 5, .5), rgba(0, 0, 5, .5)), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat center;
  display: flex;
	align-items: center;
	min-height: 480px;
	width: auto;
  height: 500px;
	justify-content: center;
	background-position: center;
}

.hero_inner {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 12px;
    background-size: cover;
    height: 80vh;
    width: 100%;
    text-align: center;
    justify-content: center;
    background-position: center;
    position: absolute;
}

.hero_title {
    color: #ffcc00;
    font-weight: 600;
    font-size: 72px;
    text-shadow: 1px 1px #252B48;
}

.hero_tagline1 {
    color: #EAEAEA;
    text-shadow: 1px 1px #252B48;
    font-size: 36px;
    font-weight: 600;
}

.hero_tagline2 {
  color: #F7E987;
  text-shadow: 1px 1px #252B48;
  font-size: 30px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/styles/hero.css"],"names":[],"mappings":"AAAA;EACE,wHAAyH;EACzH,aAAa;CACd,mBAAmB;CACnB,iBAAiB;CACjB,WAAW;EACV,aAAa;CACd,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".hero {\n  background: linear-gradient(rgba(0, 0, 5, .5), rgba(0, 0, 5, .5)), url(\"/src/public/images/hero-image.jpg\") repeat center;\n  display: flex;\n\talign-items: center;\n\tmin-height: 480px;\n\twidth: auto;\n  height: 500px;\n\tjustify-content: center;\n\tbackground-position: center;\n}\n\n.hero_inner {\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-radius: 12px;\n    background-size: cover;\n    height: 80vh;\n    width: 100%;\n    text-align: center;\n    justify-content: center;\n    background-position: center;\n    position: absolute;\n}\n\n.hero_title {\n    color: #ffcc00;\n    font-weight: 600;\n    font-size: 72px;\n    text-shadow: 1px 1px #252B48;\n}\n\n.hero_tagline1 {\n    color: #EAEAEA;\n    text-shadow: 1px 1px #252B48;\n    font-size: 36px;\n    font-weight: 600;\n}\n\n.hero_tagline2 {\n  color: #F7E987;\n  text-shadow: 1px 1px #252B48;\n  font-size: 30px;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
